<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-panel-top-section" @mouseover="mouseOver($el)" @mouseout="mouseOut($el)">
    <carousel 
      ref="carousel"
      v-if="topSectionData.data"
      :perPage="numTabsPerPage"
      :scrollPerPage="false"
      :mouseDrag="false"
      @page-change="handleChange"
      navigationNextLabel="<div class='right-arrow'></div>"
      navigationPrevLabel="<div class='left-arrow'></div>"
      :navigationEnabled="true" class="overview-table" border="0" cellspacing="0" cellpadding="0">
      
      <slide v-for="(item, index) in topSectionData.data" :key="index" v-bind:class="{'selected':tabPageNumber == index }">
        <td>
          <el-tooltip popper-class="sub-header-info-poppers" class="item" effect="dark" placement="bottom">
            <div slot="content" v-if="item.suffixKey">{{item.suffixKey.includes("Cost")?  "$"+ (Math.round(item.value * 100)/100).toLocaleString('en-US').toString(): isNaN(item.value)? item.value:(Math.round(item.value * 100)/100).toLocaleString('en-US').toString() + item.suffix.toString()}}</div>
            
            <div class="tab-section" @click="sectionChange(item, index)">
              <div :title="item.fullLabel" class="stats-title">
                {{item.label}}
              </div>
              <div class="stats">
                <div v-if="(item.displayValue||item.displayValue==0)&&item.displayValue!='N/A'" class="display-value-flex">
                  <div v-if="item.valueSuffix" class="section-value">{{item.prefix}}{{item.displayValue}}{{item.valueSuffix}}</div>
                  <div v-else class="section-value">{{item.prefix}}{{item.displayValue}}{{item.suffix}}</div>
                  <div class="div-trend-graph" v-html="item.trendGraph"></div>
                </div>

                <div v-else class="no-data-section-value">N/A</div>
              </div>
            </div> 
          </el-tooltip>
        </td>
      </slide>
    </carousel>
    <div class="blank-space" v-else></div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Carousel, Slide } from 'vue-carousel';

  export default Vue.extend({
    name: 'wy-panel-top-section',
    props: ['controller', 'topSectionData'],
    components: { 
      'carousel': Carousel,
      'slide': Slide,

    },

    data() {
      return {
        module: this,
        loading: false,
        sectionData: {},
        tabPageNumber: 0,
        openDelay: 1000,
        preTabPageNumber: 0
      }
    },
    computed: {
      numTabsPerPage() {
        let numTabs = 4;
        if(this.topSectionData.numTabsPerPage) {
          numTabs = this.topSectionData.numTabsPerPage
        }
        return numTabs
      }
    },
    methods: {
      mouseOver(el) {
        if(el.querySelector('.VueCarousel-navigation-next')) {
          el.querySelector('.VueCarousel-navigation-next').classList.add("show")
        }
        if(el.querySelector('.VueCarousel-navigation-prev')) {
          el.querySelector('.VueCarousel-navigation-prev').classList.add("show")
        }
      },

      mouseOut(el) {
        if(el.querySelector('.VueCarousel-navigation-next')) {
          el.querySelector('.VueCarousel-navigation-next').classList.remove("show")
        }
        if(el.querySelector('.VueCarousel-navigation-prev')) {
          el.querySelector('.VueCarousel-navigation-prev').classList.remove("show")
        }
      },

      sectionChange(section, index) {
        this.controller.changeDateRange(this.controller.dateRange)
        this.tabPageNumber = index;
        section = this.topSectionData.data[index];
        this.controller.preSelectedTabKey = section.key;
        this.controller.dataIndex = index;
        this.topSectionData.data.forEach(item => {
          item.selected = false;
        });
        this.topSectionData.data[index].selected = true;
        section.selected = true;
        this.controller.sectionData = section;
        if(section.lineChartData) {
          this.controller.legendData['legends'] = section.lineChartData.legends
        }
        if(section.pieChartData) {
          this.controller.legendData['legends'] = section.pieChartData.legends
        }
        if(this.controller.$refs.tabSection) {
          this.controller.$refs.tabSection.$refs.tabBottomSection.renderLegends();
        }
      },

      reRenderTabUI(pannelData, preSelectedTabKey, dataIndex) {
        let foundKey = false;
        pannelData.data.forEach((tabData, index) => {
          if(tabData.key == preSelectedTabKey) {
            foundKey = true;
            dataIndex = index;
            this.tabPageNumber = index;
          }
        })
        if(!foundKey) {
          dataIndex = 0;
          this.tabPageNumber = 0;
        }
        preSelectedTabKey = pannelData.data[dataIndex].key;
        if(this.$refs.carousel) {
          if(dataIndex >= this.numTabsPerPage) {
            this.$refs.carousel.goToPage(dataIndex - this.numTabsPerPage + 1)
          }
          else {
            this.$refs.carousel.goToPage(0)
          }
        }
        else {
          this.tabPageNumber = 0;
          dataIndex = 0;
        }
        
        return dataIndex;
      },

      handleChange(){
        // TODO
      }
    }
  });
</script>

<style lang="scss">
  .VueCarousel.overview-table.has-scroll {
    max-width: calc(100% - 194px);
  }
  .VueCarousel.overview-table {
    .VueCarousel-slide {
      &:hover{
        background: #F4F6F8;
      }
    }
    // .VueCarousel-inner {
    //   flex-basis: 25% !important;
    // }
    // .VueCarousel-inner.three {
    //   flex-basis: 33.3% !important;
    // }
    .VueCarousel-slide.selected {
      border-bottom: 0.2vw #000 solid;
    }
    .VueCarousel-navigation-next.show{
      display: block !important;
    }
    .VueCarousel-navigation-prev.show{
      display: block !important;
    }
    .VueCarousel-navigation-next{
      right: 60px !important;
      top: 70%;
      outline: none !important;
      display: none;

      .right-arrow {
        background: url('../../assets/icons/icon_right_arrow.svg') no-repeat;
        background-position-y: 0px;
        background-position-x: 0px;
        background-size: 45px;
        width: 85px;
        height: 85px;
      }
    }
    .VueCarousel-navigation-prev{
      left: 97px !important;
      top: 70%;
      outline: none !important;
      display: none;

      .left-arrow {
        background: url('../../assets/icons/icon_left_arrow.svg') no-repeat;
        background-position-y: 0px;
        background-position-x: 0px;
        background-size: 45px;
        height: 85px;
        width: 85px;
      }
    }
    .VueCarousel-navigation-prev.show.VueCarousel-navigation--disabled {
      display: none !important;
    }
    .VueCarousel-navigation-next.show.VueCarousel-navigation--disabled {
      display: none !important;
    }
  }
  .display-value-flex{
    display: flex;
    align-items: center;
  }
  .VueCarousel-pagination {
    display: none !important;
  }
  .wy-panel-top-section {
    .overview-table {
      padding-left: 0px;
      background-color: #FFF;
      border-bottom: 1px #CAD2DA solid;
      width: 100%;

      .VueCarousel-slide:first-child {
        .tab-section {
          padding-left: 14px !important;
          width: calc(100% - 14px) !important;
          // .stats, .stats-title {  
          //   padding-left: 2px;
          // }
        }
      }
      td {
        .tab-section {
          border-bottom: 0.2vw transparent solid;
          text-align: left;
          padding: 18px 14px !important;
          padding-right: 0px !important;
          // padding: 28px 15px 8px 15px;
          padding-top: 20px;
          // padding-left: 25px;
          // padding-right: 0.45vw;
          cursor: pointer;
          width: 100%;

          .stats {
            font-size: 1.67vw;
            // font-size: 1.7vw !important;
            font-weight: 400;
            // margin-right: 0.25vw;
            color: var(--site-font-secondary-color);
            padding-left: 0.25vw;
            // display: inline-flex;
            display: flex;
            font-family: Helvetica Neue, Helvetica;

            .div-trend-graph {
              margin-left: auto;
            }
          }
          .stats-title {
            font-size: 0.87vw;
            // font-size: 0.8vw;
            color: var(--site-font-tertiary-color);
            margin-bottom: 0.3vw;
            padding-left: 0.25vw;
            font-family: Helvetica Neue, Helvetica;
            max-width: 60px;
            white-space: nowrap;
            // height: 35px;
          }
          .section-value {
            // margin-right: 0.25vw;
            color: var(--site-font-secondary-color);
            margin-right: 0.5vw;
            font-size: 1.4vw;
          }
          .no-data-section-value{
            color: var(--site-font-secondary-color);
            margin-right: 0.5vw;
            font-size: 1.4vw;
            height: 32px;
          }
          svg.ct-chart-line {
            width: 100% !important;
            height: 25px!important;
          }
        }
        .tab-section.selected {
          border-bottom: 0.2vw #000 solid;
        }
      }
    }

    .blank-space {
      height: 105px
    }
  }

</style>